import { LoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'
import Styles from './SelectImageContent.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import { isVideo } from 'components/ImagePickerModal/utils'
import { VideoLoadingSpinner } from './components/VideoLoadingSpinner/VideoLoadingSpinner'
import { useState } from 'react'
import * as CSS from 'csstype'

interface Props {
  thumbnailUrl?: string
  type?: string
  loadedPercentage?: number
}

export const ConfirmVideo = ({ thumbnailUrl, type, loadedPercentage }: Props) => {
  const imagePickerContext = useImagePickerContext()
  const { isUploading, selectedImages } = imagePickerContext
  const [videoWidth, setVideoWidth] = useState<number>()
  const [videoHeight, setVideoHeight] = useState<number>()

  const isLibraryVideo = !!selectedImages[0]?.id && !selectedImages[0]?.pixabay
  const isThumbnailVideoUrl = isVideo({ url: thumbnailUrl, type })

  const style: CSS.Properties = {
    ['--shimmerer-width' as any]: `${videoWidth}px`,
    ['--shimmerer-height' as any]: `${videoHeight}px`,
  }

  return (
    <div className={Styles.confirmVideoContainer}>
      <div className={Styles.confirmVideo}>
        <Heading level={1}>Confirm video selection</Heading>
        {((!isUploading && loadedPercentage === undefined) || isLibraryVideo) && (
          <video src={selectedImages[0]?.source_url} controls />
        )}
        {(isUploading || loadedPercentage !== undefined) && !isLibraryVideo && (
          <>
            <LoadingShimmerer shimmererClassName={Styles.shimmer} style={style}>
              {isThumbnailVideoUrl ? (
                <video
                  src={thumbnailUrl}
                  controls={false}
                  muted
                  onLoadedMetadata={(data) => {
                    setVideoWidth(data.currentTarget.clientWidth)
                    setVideoHeight(data.currentTarget.clientHeight)
                  }}
                />
              ) : (
                <img src={thumbnailUrl} alt="selected" />
              )}

              {thumbnailUrl && <VideoLoadingSpinner size={56} percentage={loadedPercentage} />}
            </LoadingShimmerer>
            <div className={Styles.loadingLabel}>
              <Text variant="largeList" color="var(--dark-40)">
                Uploading video
                <LoadingEllipses />
              </Text>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
